import { DevelopmentConfig } from './development'
import { ProductionConfig } from './production'
import { DemoConfig } from './demo'

import { ENVIRONMENT } from './environment'

export interface IConfig {
  apiServerHost: string
  apiServerPort: number
  apiServerTenant?: string
  ssl: boolean
  googleOAuthClientId?: string
  microsoftOAuthClientId?: string
}

function loadConfig(env: 'development' | 'production' | 'demo'): IConfig {
  switch (env) {
    case 'development': return DevelopmentConfig
    case 'production': return ProductionConfig
    case 'demo': return DemoConfig
  }
}

export const AppConfig = loadConfig(ENVIRONMENT)

export function buildHttpHost(config: IConfig): string {
  let result = `${config.ssl ? 'https' : 'http'}://${config.apiServerHost}`
  const port = config.apiServerPort
  if (port !== 80 && port !== 443) result += `:${port}`
  if (config.apiServerTenant) {
    result += `/tenants/${config.apiServerTenant}`
  }

  return result
}

export function buildWsHost(config: IConfig): string {
  let result = `${config.ssl ? 'wss' : 'ws'}://${config.apiServerHost}`
  const port = config.apiServerPort
  if (port !== 80 && port !== 443) result += `:${port}`
  if (config.apiServerTenant) {
    result += `/tenants/${config.apiServerTenant}`
  }

  return result
}

export function buildActiveStorageHost(config: IConfig): string{
  let result = `${config.ssl ? 'https' : 'http'}://${config.apiServerHost}`
  const port = config.apiServerPort
  if (port !== 80 && port !== 443) result += `:${port}`
  result += '/rails/active_storage'

  return result
}

export function httpHost(): string {
  return buildHttpHost(AppConfig)
}

export function wsHost(): string {
  return buildWsHost(AppConfig)
}

export function activeStorageHost(): string{
  return buildActiveStorageHost(AppConfig)
}



// WEBPACK FOOTER //
// ./src/config/index.ts